module.exports = __webpack_public_path__ + "static/media/blog3.08696b6b.webp";